import React from 'react';
import { useAtnaConversation } from '../../hooks/useAtnaConversation';
import { useRequests } from '../../contexts/RequestsContext';
import { buildReportedRequest } from '../../data/demandes';
import { AtnaDialogShell } from '../atna/AtnaDialogShell';
import { AtnaMessage } from './AtnaMessage';
import type { AtnaTurnKind } from '../../types/demandes';
interface AtnaConversationDialogProps {
  initialText: string;
  onClose: () => void;
  /** Shared layout id: the launcher pill morphs into this panel. */
  layoutId: string;
  /** Opened from a quick shortcut: skip the "J'ai compris" step and ask for the location. */
  direct?: boolean;
  /** Lieu déjà choisi (clic sur la carte) : l'étape « Où se trouve le problème ? » est sautée. */
  presetAddress?: string;
  /** Appelé à l'envoi, avec le type de problème reconnu (ex. pour ajouter le point sur la carte). */
  onSent?: (intentLabel: string) => void;
}
export function AtnaConversationDialog({
  initialText,
  onClose,
  layoutId,
  direct = false,
  presetAddress,
  onSent
}: AtnaConversationDialogProps) {
  const {
    addRequest
  } = useRequests();
  const {
    turns,
    thinking,
    draft,
    setDraft,
    submitDraft,
    description,
    intent,
    setIntent,
    setAddress,
    address,
    answer,
    setAnswer,
    hasPhoto,
    attachPhoto,
    exchange,
    detect,
    liveAtnaId,
    lastAtnaKind,
    pickProblem,
    startOver,
    pickHelpTopic,
    followUp,
    startNewReport,
    hasPresetAddress
  } = useAtnaConversation(initialText, direct, presetAddress);
  return <AtnaDialogShell layoutId={layoutId} subtitle="Signaler un problème" onClose={onClose} turns={turns} thinking={thinking} liveAtnaId={liveAtnaId} footnote="ATNA peut se tromper. Vérifiez le résumé avant d’envoyer votre demande." satisfaction={lastAtnaKind === 'succes' || lastAtnaKind === 'suivi-merci'} prompt={{
    value: draft,
    onChange: setDraft,
    onSubmit: submitDraft,
    onAddPhoto: attachPhoto,
    photoAttached: hasPhoto,
    placeholder: lastAtnaKind === 'succes' || lastAtnaKind === 'suivi-merci' || lastAtnaKind === 'aide' ? 'Décrivez ce que vous voulez signaler…' : lastAtnaKind === 'suivi' && followUp?.question ? 'Répondre à la Ville…' : 'Répondre à ATNA, ou préciser votre demande…'
  }} renderAtna={(kind, live) => <AtnaMessage kind={kind as AtnaTurnKind} live={live} intent={intent} address={address} description={description} answer={answer} hasPhoto={hasPhoto} onConfirmIntent={() => exchange('Oui, c’est bien ça', hasPresetAddress ? hasPhoto ? 'detail' : 'photo' : 'lieu')} onPickProblem={pickProblem} followUp={followUp} onNewProblem={startNewReport} onPickIntent={setIntent} onNotEmergency={() => {
    setIntent(detect(description));
    exchange('Ce n’est pas une urgence', 'comprehension');
  }} onPickAddress={(picked, source) => {
    setAddress(picked);
    exchange(source === 'position' ? `Ma position : ${picked}` : picked, hasPhoto ? 'detail' : 'photo');
  }} onAddPhoto={attachPhoto} onSkipPhoto={() => exchange('Continuer sans photo', 'detail')} onAnswer={option => {
    setAnswer(option);
    exchange(option, 'revue');
  }} onSend={() => {
    // Le signalement devient une requête « Reçue », visible aussitôt dans « Mes demandes ».
    addRequest(buildReportedRequest({
      title: intent.label,
      service: intent.service,
      address,
      description: answer ? `${description} — ${answer}` : description,
      hasPhoto
    }));
    onSent?.(intent.label);
    exchange('Envoyer ma demande', 'succes');
  }} onEdit={() => exchange('Je veux modifier ma demande', 'comprehension')} onReset={startOver} onPickHelpTopic={pickHelpTopic} data-id="element-1083" data-mp="1lf2ie8dq8zw5" />} data-id="element-1082" data-mp="1m7ap0b2upz9j" />;
}